import React, { memo, HTMLAttributes } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IMenuLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  /**
   * @example 'https://transfix.io'
   */
  href?: string
}

const useMenuLinkStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  text: {
    color: brandColors.skyBlue6,
  },
}))

const MenuLink = memo<IMenuLinkProps>(({ children, href = '', ...props }) => {
  const classes = useMenuLinkStyles()
  return (
    <a href={href} className={classes.root} {...props}>
      <Typography variant='button' component='div' className={classes.text}>
        {children}
      </Typography>
    </a>
  )
})

export default MenuLink
